import { render } from "./START_EID.vue?vue&type=template&id=6238fe9c"
import script from "./START_EID.vue?vue&type=script&lang=js"
export * from "./START_EID.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__